export const CSS_CLASSES = {
	LABEL_ACCEPT: 'accept-decline__option--accept__label--active',
	LABEL_DECLINE: 'accept-decline__option--decline__label--active',
};

/**
 * Radio instance unique identifiers.
 * @type {Object}
 */
export const VALUES = {
	ACCEPT: 'accept',
	DECLINE: 'decline',
};
